import { render, staticRenderFns } from "./ParentBirthday.vue?vue&type=template&id=c30b79a8&scoped=true"
import script from "./ParentBirthday.vue?vue&type=script&lang=js"
export * from "./ParentBirthday.vue?vue&type=script&lang=js"
import style0 from "./ParentBirthday.vue?vue&type=style&index=0&id=c30b79a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30b79a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c30b79a8')) {
      api.createRecord('c30b79a8', component.options)
    } else {
      api.reload('c30b79a8', component.options)
    }
    module.hot.accept("./ParentBirthday.vue?vue&type=template&id=c30b79a8&scoped=true", function () {
      api.rerender('c30b79a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/birthdaymanagement/ParentBirthday.vue"
export default component.exports